import * as React from 'react';
import { SyntheticEvent } from 'react';

interface Props {
    labelText?: string;
    helpText?: string;
    helpTextClass?: string;
    name: string;
    onChange: (inputName: string, newValue: string | number) => void;
    placeholder?: string;
    showIcon: boolean;
    validIcon: boolean;
    type?: string;
    disabled?: boolean;
    minLength?: number;
    maxLength?: number;
    value?: string | number;
    invalidIconText?: string;
    boldTitle?: boolean;
}

let validIcon = require('../../../images/form-valid.png');
let invalidIcon = require('../../../images/form-error.png');

const InputWithValidationIcon = (props: Props) => {
    const inputChanged = (e: SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        props.onChange(props.name, e.currentTarget.value);
    };

    return (
        <div>
            {props.labelText && (
                <label
                    style={
                        props.boldTitle
                            ? { fontWeight: 'bold', marginBottom: 0 }
                            : { marginBottom: 0 }
                    }
                >
                    {props.labelText}
                </label>
            )}

            <div className="icon-input-container">
                <input
                    className="icon-input form-control"
                    onChange={inputChanged}
                    placeholder={props.placeholder}
                    type={props.type}
                    disabled={props.disabled}
                    minLength={props.minLength}
                    maxLength={props.maxLength}
                    value={props.value || ''}
                />
                {props.showIcon && (
                    <div className="icon-container">
                        {props.invalidIconText && !!!props.validIcon && (
                            <span className="invalid-icon-text">{props.invalidIconText}</span>
                        )}
                        <img
                            src={props.validIcon ? validIcon : invalidIcon}
                            className="valid-or-invalid-icon"
                        />
                    </div>
                )}
            </div>
            {props.helpText && (
                <small
                    className={
                        props.helpTextClass || 'form-text text-muted password-reset-helptext'
                    }
                >
                    {props.helpText}
                </small>
            )}
        </div>
    );
};

export default InputWithValidationIcon;



// WEBPACK FOOTER //
// ./src/components/common/form/InputWithValidationIcon.tsx